<template>
  <div class="tabs is-toggle has-custom-scrollbar">
    <ul>
      <li
        v-for="(item, index) in menuItems"
        :key="'m_' + index"
        :class="$route.name.includes(item.view) ? 'is-active' : 'has-background-white'"
      >
        <router-link :to="{
          name: item.view, params: {
            locationId: locationId
          } }">
          {{ item.label }}
        </router-link>
        <!-- <a @click="setVisibleItem(item.view)">
          <span>{{ item.label }}</span>
        </a> -->
      </li>
    </ul>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { mapGetters } from 'vuex/dist/vuex.common'

export default {
  name: 'LocationMenu',

  data() {
    return {}
  },

  computed: {
    ...mapState('locationStore', [
      'locationDetail',
    ]),

    ...mapGetters('locationStore', ['locationId']),

    menuItems() {
      return [
        {
          label: 'Location data',
          action: () => { },
          view: 'locations-location-detail',
        },
        {
          label: 'Settings',
          action: () => { },
          view: 'locations-location-settings',
        },
        {
          label: 'Opening hours',
          action: () => { },
          view: 'locations-location-openinghours', // Was open
        },
        {
          label: 'Descriptions',
          action: () => { },
          view: 'locations-location-description', // Was text
        },
        {
          label: 'Images',
          action: () => { },
          view: 'locations-location-images',
        },
        {
          label: 'Videos',
          action: () => { },
          view: 'locations-location-videos',
        },
        {
          label: 'Accounts',
          action: () => { },
          view: 'locations-location-accounts',
        },
        {
          label: 'Spaces',
          action: () => { },
          view: 'locations-location-spaces',
        },
        {
          label: 'Options',
          action: () => { },
          view: 'locations-location-options',
        },
        {
          label: 'Yield',
          action: () => { },
          view: 'locations-location-yield',
        },
        {
          label: 'Vouchers',
          action: () => { },
          view: 'locations-location-vouchers',
        },
        {
          label: 'Subscriptions',
          action: () => { },
          view: 'locations-location-subscriptions',
        }
      ]
    }
  },

  methods: {
    ...mapMutations('locationStore', ['setLocationDetail']),

    setVisibleItem(item) {
      this.locationDetail.visibleItem = item
      this.setLocationDetail(this.locationDetail)
    },
  }

}
</script>